/**
 * Created by comoon on 1/28/16.
 */

var React = require('react');

var $ = require("jquery");

var ReactDOM = require('react-dom');

var _ = require("underscore");

var ALikeStore = require("../store/ALikeStore");

var Dispatcher = require("../Dispatcher");

var {ActionConstants, ElementConstants, EventConstants} = require("../Constants");

var Tip = require("../cutil/Tip");

var {format} = require("../util/price");

var TripType = require("../conf/trip-type");

var TripGrade = require("../conf/trip-grade");

var Calendar = require("../cutil/Calendar.jsx");

var productUtils = require('../util/productUtils');

var {ProductTableContainer, Cell,CellTitle, CellContent } = require('./ProductTableContainer');

var { ProductDescribe, ProductDescribeDetail, AirTicketDescribe, HotelDescribeDetail,HotelDescribeDetailA } = require('./ProductDescribe');

var {AHEAD_MIN_DATE,AHEAD_MAX_DATE} = require('../conf/booking-conf');

module.exports = React.createClass({
    displayName: "ProductListApp",
    getInitialState(){
        return {
            productListLoading:false,
            productInfo: null,
            planeInfo: null,
            gradeType: ALikeStore.get_gradeType(),
            startDate: moment().add(50, 'days').format("YYYY-MM-DD"),
            defaultStart : true,
            showDefaultProductInfo: false
        };
    },
    componentWillMount(){

        ALikeStore.on(EventConstants.PRODUCT_LIST_LOADING, this.on_productListLoading);

        ALikeStore.on(EventConstants.AJAX_LOAD_PRODUCT_LIST_COMPLETE, this.on_productInfoChange);

        ALikeStore.on(EventConstants.ACTION_SWITCH_QUOTE_RECORD_COMPLETE, this.on_switchQuoteRecordComplete);

        ALikeStore.on(EventConstants.ACTION_TWEAK_QUOTE_START, this.on_tweakQuoteStart);

        ALikeStore.on(EventConstants.ACTION_SWITCH_GRADE_TYPE, this.on_switchGradeComplete);

        ALikeStore.on(EventConstants.START_DATE_CHANGE, this.on_startDateChange);
    },
    componentWillUnmount(){


        ALikeStore.off(EventConstants.PRODUCT_LIST_LOADING, this.on_productListLoading);

        ALikeStore.off(EventConstants.AJAX_LOAD_PRODUCT_LIST_COMPLETE, this.on_productInfoChange);

        ALikeStore.off(EventConstants.ACTION_SWITCH_QUOTE_RECORD_COMPLETE, this.on_switchQuoteRecordComplete);

        ALikeStore.off(EventConstants.ACTION_TWEAK_QUOTE_START, this.on_tweakQuoteStart);

        ALikeStore.off(EventConstants.ACTION_SWITCH_GRADE_TYPE, this.on_switchGradeComplete);

        ALikeStore.off(EventConstants.START_DATE_CHANGE, this.on_startDateChange);
    },
    componentDidUpdate(preState){
        if (this.state.hasService != preState.hasService) {
            if (this.state.hasService|| (!this.state.hasService && preState.absent)) {
                var serviceWrapper = ReactDOM.findDOMNode(this.refs.serviceWrapper);
                $(serviceWrapper).InterestPoints({
                    type: 4,
                    hasHead: false,
                    isVertical: true,
                    hasContent: true,
                    hasGo: true,
                    logParams: '&rf=liyidianrukoujqzl_zhunapcdown'
                });

            }
        }
    },
    on_switchGradeComplete(){

        this.setState({
            gradeType: ALikeStore.get_gradeType()
        })

    },
    on_productInfoChange(){

        var productInfo = ALikeStore.get_currentProductList(!this.props.absent);
        if(!productInfo){
            this.setState({productInfo});
            return
        }
        //机票信息 Tips用到
        var planeInfo = ALikeStore.get_planeInfo();
        var hasService = true;//默认包含服务包
        var versionId = ALikeStore.get_currentVersion();

        if (versionId) {
            var version = ALikeStore.get_versionDetail(ALikeStore.get_currentVersion());
            hasService = version.hasService;
            planeInfo = ALikeStore.get_planeInfo(versionId);

            this.setState({
                productListLoading: false
            });
        }

        this.setState({productInfo, hasService, planeInfo});

    },
    on_productListLoading( isLoading ){

        this.setState({
            productListLoading: isLoading
        });

    },
    on_switchQuoteRecordComplete(){

      this.setState({showDefaultProductInfo: false});

    },
    on_tweakQuoteStart(){
        var self = this;
        var quote = ALikeStore.get_recordDetail(ALikeStore.get_currentRecord());
        var gradeType = quote.grade;
        this.setState({showDefaultProductInfo: true},function(){
            self.handle_toggleTripGrade(gradeType);
        });

    },

    on_startDateChange( startDate ){

        var defaultStart = false;
        this.setState({startDate,defaultStart});
    },

    handle_moveToUncontains(){

        var top = $("#priceUncontain").offset().top - $(ElementConstants.TOP_NAV_CLASS).height();

        $(window).scrollTop(top);
    },
    handle_toggleTripGrade(gradeType){

        var tripInfo = ALikeStore.get_tripBasicInfo();
        var versionId = gradeType === TripGrade.Enjoy.code ? tripInfo.versionId : tripInfo.luxuryVersionId ;
        var data = {
            versionId: versionId,
            gradeType: gradeType
        };
        Dispatcher.dispatch({type: ActionConstants.SWITCH_GRADE_TYPE, data: data});
    },
    /**
     * 商品是否显示数量
     */
    hasNum(){

        var tripInfo = ALikeStore.get_tripBasicInfo();

        var isTripB = (tripInfo.tripType === TripType.WalleB.code) ? true: false;

        var isDefaultProductInfo = ALikeStore.is_defaultProductInfo() || this.state.showDefaultProductInfo;

        return !isDefaultProductInfo || isTripB;
    },
    render(){
        var props = this.props;
        var absent = props.absent;
        var isAbsent = ALikeStore.isAbsent();
        var trip = ALikeStore.get_tripBasicInfo();

        //准AA or 准AB
        var isTripA = (trip.tripType === TripType.WalleA.code) ? true: false;

        this.tips = ALikeStore.get_productTips();

        if (!this.state.productInfo) {

            return null;
        }
        var isDefaultProductInfo = ALikeStore.is_defaultProductInfo();
        var showDefaultProductInfo = this.state.showDefaultProductInfo;

        return (
            <div className="price-profile-iml" id={`price${absent ? 'Uncontain' : 'Contain'}`}>
                { absent ?
                    this.render_outPriceTitle() :
                    this.render_inPriceTitle()
                }
                <div className="mod-product-table">
                    {
                        !absent && isTripA ? (
                            isDefaultProductInfo || showDefaultProductInfo ? (
                                this.render_defaultGrade()
                            ) : (
                                this.render_currentGrade()
                            )
                        ):null

                    }
                    <div className="bd-padding">
                        <ProductTableContainer isLoading={ this.state.productListLoading }>
                            {this.render_airTicketItem()}
                            {this.render_hotelItem()}
                            {this.render_tourItem()}
                            {this.render_eurailItem()}
                            {this.render_carRentItem()}
                            {this.render_pickupItem()}
                            {this.render_visaItem()}
                            {this.render_insuranceItem()}
                            {this.render_wifiItem()}
                            {this.render_otherItem()}
                            {this.render_service()}
                        </ProductTableContainer>
                    </div>
                </div>
                <div className="mod-calendar">
                {
                    isAbsent ? (
                        absent && isTripA ? (
                            <div>
                                <h3 className="title mod-title">
                                    <span className="main">价格日历</span>
                                </h3>
                                {this.render_tripCalendar()}
                            </div>
                        ) : null
                    ) : (
                        !absent && isTripA ? (
                            <div>
                                <h3 className="title mod-title">
                                    <span className="main">价格日历</span>
                                </h3>
                                {this.render_tripCalendar()}
                            </div>
                        ) : null
                    )
                }
                </div>

            </div>
        );
    },
    /**
     * 包含
     * @returns {XML}
     */
    render_inPriceTitle(){
        var isAbsent = ALikeStore.isAbsent();
        return (
            <h3 className="title mod-title">
                <span className="main">价格包含</span>
                {
                    isAbsent ? (<span onClick={this.handle_moveToUncontains} className="vice c-link"
                                        style={{cursor: 'pointer'}}>查看价格未包含内容 <i className="icon-product-more"></i> </span>) : null
                }
            </h3>
        );
    },
    /**
     * 未包含
     * @returns {XML}
     */
    render_outPriceTitle(){
        var trip = ALikeStore.get_tripBasicInfo();
        var chatId  = trip.chatId || 0;
        var chatUser  = trip.chatUser || 0;
        var dataId = chatId ? chatId : chatUser;
        return (
            <h3 className="title mod-title">
                <span className="main c-orange">价格未包含</span>
                <span className="price-talk c-blue webim-online-click tl-im" data-id={dataId}>询价请咨询旅行顾问 <span><i className="icon-product-talk-blue"></i>在线咨询</span></span>
            </h3>
        );
    },
    /**
     * 默认行程,tab切换
     */
    render_defaultGrade(){
        var tripInfo = ALikeStore.get_tripBasicInfo();
        var price = format(tripInfo.price);
        var luxuryPrice = format(tripInfo.luxuryPrice);
        var gradeType = ALikeStore.get_gradeType();
        return(
            <ul className="cell-tabs">
                <li className={(+gradeType === 0) ? "f-tab-t c-tab current" : "f-tab-t c-tab"} onClick={(e)=> this.handle_toggleTripGrade(0)}>
                    <h3 className="title">
                        <i className={(+gradeType === 0) ? "icon-super-detail-radio-b-checked" : "icon-super-detail-radio-b"}></i>
                        <span className="main">{TripGrade.Enjoy.name}</span>
                        <span className="price ng-scope">
                            {
                                +tripInfo.price ? (
                                    <span><em>{price}</em>元/人起（参考价）</span>
                                ):(
                                    <span>需询价</span>
                                )
                            }
                        </span>
                    </h3>
                </li>
                <li className={(+gradeType === 1) ? "f-tab-t c-tab current" : "f-tab-t c-tab"} onClick={(e)=> this.handle_toggleTripGrade(1)}>
                    <h3 className="title">
                        <i className={(+gradeType === 1) ? "icon-super-detail-radio-b-checked" : "icon-super-detail-radio-b"}></i>
                        <span className="main">{TripGrade.Luxury.name}</span>
                        <span className="price ng-scope">
                            {
                                +tripInfo.luxuryPrice ? (
                                    <span><em>{luxuryPrice}</em>元/人起（参考价）</span>
                                ):(
                                    <span>需询价</span>
                                )
                            }
                        </span>
                    </h3>
                </li>
            </ul>
        )
    },
    /**
     * 当前的类型,品质,优选
     */
    render_currentGrade(){
        var quote = ALikeStore.get_recordDetail(ALikeStore.get_currentRecord());
        var grade = quote.grade;
        var gradeName = grade>=0 ? _.findWhere(TripGrade, {code: grade}).name : null;
        if(!gradeName){
            return;
        }
        return(
            <div className="grade-type">
                <h3 className="title">
                    <i className="icon-indicator-radio-gray-checked"></i>
                    <span className="main">{gradeName}</span>
                </h3>
            </div>
        )
    },
    render_airTicketItem(){

        var absent = this.props.absent;
        var planes = this.state.productInfo.plane;
        var plantInfo = this.state.planeInfo;

        if (!planes) {
            return null;
        }

        return (
            <Cell>
                <CellTitle>
                    <i className="icon-super-detail-p1"/>
                    <h4>机票</h4>
                </CellTitle>
                <CellContent loadingContent="正在为您挑选符合行程大师航班标准的国际及内陆段航班">

                    <AirTicketDescribe data={planes} plantInfo={ plantInfo } hasNum={this.hasNum()} absent={absent} />

                </CellContent>
            </Cell>
        );
    },
    render_hotelItem(){

        var absent = this.props.absent;

        var hotels = productUtils.sortByDays(this.state.productInfo.hotel);

        var currentGradeType = ALikeStore.get_gradeType();

        if (!hotels || (hotels.length === 0)) {

            return null;
        }
        var trip = ALikeStore.get_tripBasicInfo();
        //准AA or 准AB
        var isTripA = (trip.tripType === TripType.WalleA.code) ? true: false;

        // 行程级别
        var quote = ALikeStore.get_recordDetail(ALikeStore.get_currentRecord());
        var grade,gradeName;

        if( quote) {
            grade = quote.grade;
            gradeName = grade>=0 ? _.findWhere(TripGrade, {code: grade}).prefix : null;
        }else{
            gradeName = TripGrade.list[ currentGradeType ].prefix;
        }

        return (
            <Cell>
                <CellTitle>
                    <i className="icon-super-detail-p2"/>
                    <h4>酒店</h4>
                </CellTitle>
                <CellContent loadingContent="正在挑选符合您本次行程安排的酒店">

                    <h5>全程精选{ gradeName }酒店：</h5>
                    <ul className="item-list">
                        {
                            !isTripA
                                ? <HotelDescribeDetailA data={hotels} productType={ 'hotel' } hasFullName={true}
                                                         hasNum={this.hasNum()}  />
                                : <HotelDescribeDetail data={hotels} hasNum={this.hasNum()}  />
                        }
                    </ul>
                    {
                        !absent ? (
                           <div>
                               <div className="hotel-desc info">* 考虑到行程安排、酒店房型库存等原因，实际预定时可能会选用其他同级别酒店</div>

                               <dl className="cell-serve-standard">
                                   <dt>挑酒店，我们有三不！</dt>
                                   <dd>
                                       <ul>
                                           <li>
                                               <p className="title">不只看星级</p>
                                               <p>
                                                   是否安全、便利、是否对华人友好……都是我们考虑的因素，
                                                   <br />
                                                   结合百万真实用户评价，严格评分、筛选，平均100家酒店只能选出3.7家。
                                               </p>
                                           </li>
                                           <li>
                                               <p className="title">不是黄金位置的不选</p>
                                               <p>
                                                   自驾和包车行程精选贴合线路设计、行车及停车便利的高品质酒店。<br />
                                                   其他行程选择黄金地段的的精品酒店，临近交通枢纽或景点，住得惬意、步行轻松抵达。
                                               </p>
                                           </li>
                                           <li>
                                               <p className="title">不选贵的，选性价比好的</p>
                                               <p>
                                                   经过行程大师全球旅行达人亲身实地体验，<br />
                                                   从同星级酒店中，为你精选性价比更好的。
                                               </p>
                                           </li>
                                       </ul>
                                   </dd>
                               </dl>
                           </div>
                        ) :null
                    }
                </CellContent>
            </Cell>
        );
    },
    render_tourItem(){
        var tours = this.state.productInfo.tour;
        if (!tours) {
            return null;
        }
        return (
            <Cell>
                <CellTitle>
                    <i className="icon-super-detail-p3"/>
                    <h4>观光</h4>
                </CellTitle>
                <CellContent loadingContent="正在挑选旅行观光产品">
                    <ProductDescribeDetail data={tours} productType={ 'tour' } hasNum={ this.hasNum() } />
                </CellContent>
            </Cell>
        )
    },
    render_carRentItem(){

        var cars = this.state.productInfo.car;

        if (!cars) {

            return null;
        }

        return (
            <Cell>
                <CellTitle>
                    <i className="icon-super-detail-p4"/>
                    <h4>车辆</h4>
                </CellTitle>
                <CellContent loadingContent="正在挑选符合您本次行程安排的车辆">
                    <ProductDescribeDetail data={cars} productType={ 'car' } hasNum={ this.hasNum() } />
                </CellContent>
            </Cell>
        );
    },
    render_eurailItem(){
        var trains = this.state.productInfo.train;

        if (!trains || trains.length === 0) {

            return null;
        }

        return (
            <Cell>
                <CellTitle>
                    <i className="icon-super-detail-p4"/>
                    <h4>交通</h4>
                </CellTitle>
                <CellContent loadingContent="正在挑选最佳交通方式和对应产品">
                    <ProductDescribeDetail
                        data={trains}
                        productType={ 'train' }
                        hasNum={ this.hasNum() } />
                </CellContent>
            </Cell>
        );
    },
    render_pickupItem(){

        var pickups = this.state.productInfo.pickup;

        if (!pickups) {

            return null;
        }

        return (
            <Cell>
                <CellTitle>
                    <i className="icon-super-detail-p4"/>
                    <h4>车辆</h4>
                </CellTitle>
                <CellContent loadingContent="正在挑选符合您本次行程安排的车辆">
                    <ProductDescribe data={pickups} productType={ 'pickup' } hasNum={ this.hasNum() } />
                </CellContent>
            </Cell>
        );
    },
    render_wifiItem(){

        var wifis = this.state.productInfo.wifi;

        if (!wifis) {

            return null;
        }

        return (
            <Cell>
                <CellTitle>
                    <i className="icon-super-detail-p7"/>
                    <h4>设备</h4>
                </CellTitle>
                <CellContent loadingContent="正在挑选目的地移动 WI-FI 产品">
                    <ProductDescribe data={wifis} productType={ 'wifi' } hasNum={ this.hasNum() } />
                </CellContent>
            </Cell>
        );
    },
    render_insuranceItem(){

        var insurances = this.state.productInfo.insurance;

        if (!insurances) {

            return null;
        }

        return (

            <Cell>
                <CellTitle>
                    <i className="icon-super-detail-p6"/>
                    <h4>保险</h4>
                </CellTitle>
                <CellContent loadingContent="正在计算保险价格">
                    <ProductDescribe data={insurances} productType={ 'insurance' } hasNum={ this.hasNum() } />
                </CellContent>
            </Cell>
        );
    },
    render_visaItem(){

        var visas = this.state.productInfo.visa;

        if (!visas) {

            return null;
        }
        return (
            <Cell>
                <CellTitle>
                    <i className="icon-super-detail-p5"/>
                    <h4>签证</h4>
                </CellTitle>
                <CellContent loadingContent="正在挑选最佳签证服务商家">
                    <div className="cell-media-lr">
                        <div className="c-txt">
                            <ProductDescribe data={visas} productType={ 'visa' } hasNum={ this.hasNum() } />
                        </div>
                    </div>
                </CellContent>
            </Cell>
        );
    },
    render_otherItem(){

        var others = this.state.productInfo.other;

        if (!others) {

            return null;
        }

        return (
            <Cell>
                <CellTitle>
                    <i className="icon-product-other"/>
                    <h4>其他</h4>
                </CellTitle>
                <CellContent loadingContent="正在为您挑选商品">
                    <ProductDescribe data={others} />
                </CellContent>
            </Cell>
        );
    },
    render_service(){

       return (this.state.hasService && !this.props.absent) || (!this.state.hasService && this.props.absent) ? (
           <Cell>
               <CellTitle>
                   <i className="icon-super-detail-p8"/>
                   <h4>服务</h4>
               </CellTitle>
               <CellContent>
                   <div className="service-wrapper reg-interest-points-href-serve" ref="serviceWrapper">

                   </div>
               </CellContent>
           </Cell>
       ): null

    },
    handle_selectDepartDate(options){
        var startDate = this.state.startDate;
        startDate = options.string;
        var defaultStart = false;
        var data = {
            selected: options.selected
        }
        this.setState({startDate,defaultStart},function(){
            if(options.showPanel){
                Dispatcher.dispatch({type: ActionConstants.SELECTED_CALEANDAR_STARTDATE_CONFIRM, data});
            }
        });

    },
    render_tripCalendar(){
        var startDate = this.state.startDate;
        var defaultStart = this.state.defaultStart;

        return(
            <div className="panelCalendarWarp">
                <Calendar
                    selected={startDate}
                    defaultStart={defaultStart}
                    onSelect={this.handle_selectDepartDate}
                    min={moment().add(AHEAD_MIN_DATE, 'days')}
                    max={moment().add(AHEAD_MAX_DATE, 'days')}
                    showPanel={true}
                    dayNote={true}
                    titlePosition="bottom"
                    panelWrap="panelCalendarWarp"
                />
            </div>
        )
    }
});



/** WEBPACK FOOTER **
 ** ./script/detail/ProductListApp.jsx
 **/